<template>
  <div
    v-if="isSpinnerVisible"
    id="spinner"
    class="spinner-fullscreen d-flex flex-column justify-content-center align-items-center text-center"
  >
    <b-spinner :label="$t('chargement')"></b-spinner>
  </div>
  <div v-else :id="content.idHTML" :class="jel_getClassObject(content)">
    <div class="column">
      <div class="texte-noir">{{ content.libPrenom }}</div>
      <p class="texte" v-html="contentPrenom"></p>
      <div class="texte-noir">{{ content.libNom }}</div>
      <p class="texte" v-html="contentNom"></p>
      <div class="texte-noir">{{ content.libDateDeNaissance }}</div>
      <p class="texte" v-html="contentDateDeNaissance"></p>
      <div class="texte-noir">{{ content.libAdresse }}</div>
      <p class="texte" v-html="contentAdresse"></p>
    </div>
  </div>
</template>

<script>
import router from '@/router';
import store from '@/store';

import { inMgnl } from '@/helpers/AppHelpers';
import { PageMapping } from '@/helpers/PageMappingHelpers';
import { formatteDateStringToLocale } from '@/helpers/StringHelpers';

import identite from '@/services/api/compte/identite';
import session from '@/services/api/compte/session';

export default {
  name: 'FormulaireIdentiteVerification',
  props: {
    metadata: { type: Object, required: true },
    content: { type: Object, required: true },
  },
  data() {
    return {
      adresse: {
        ligneadresse: null,
        ligneAdresse2: null,
      },
      userInfo: {
        firstname: null,
        lastname: null,
        dob: null,
      },
      isSpinnerVisible: false,
    };
  },
  computed: {
    contentPrenom() {
      return this.userInfo.firstname ?? '';
    },
    contentNom() {
      return this.userInfo.lastname ?? '';
    },
    contentDateDeNaissance() {
      return this.userInfo.dob ? formatteDateStringToLocale(this.userInfo.dob) : '';
    },
    contentAdresse() {
      return this.adresse.ligneAdresse
        ? `${this.adresse.ligneAdresse}<br/>${this.adresse.ligneAdresse2}`
        : '';
    },
  },
  async beforeMount() {
    if (!inMgnl) {
      this.isSpinnerVisible = true;
      if (session.sessionEstOuverte()) {
        // TODO: Implémenter appel de service pour récupérer les infos de Vérification VerifiedMe
        /**
         * Appel du service pour récupérer les informations de vérification du client
         * en provenance de VerifiedMe
         */
        await identite
          .recupererVerificationInfo()
          .then(() => {
            this.adresse = store.state.profile.verificationDetails.adresseAffichage;
            this.userInfo = store.state.profile.verificationDetails.verification.nominativeData;
            this.isSpinnerVisible = false;
          })
          .catch((error) => {
            router
              .push(
                store.getters['routes/getUrlFromWebsitePath'](
                  error.url ?? PageMapping.ERREUR_GENERIQUE.siteUrl
                )
              )
              // Masque affichage message erreur Navigation Guard
              .catch(() => {});
          });
      } else {
        // On redirige vers la page de connexion
        router
          .push(store.getters['routes/getUrlFromWebsitePath'](PageMapping.CONNEXION.siteUrl))
          // Masque affichage message erreur Navigation Guard
          .catch(() => {});
      }
    }
  },
};
</script>
